import { Tool } from '../types';

export const tools: Tool[] = [
  {
    id: 'character-counter',
    name: '글자수 세기',
    description: '텍스트의 글자, 단어, 문장 수를 실시간으로 확인',
    icon: '📊',
    path: '/character-counter',
  },
  {
    id: 'case-converter',
    name: '대소문자 변환',
    description: '영문 텍스트를 다양한 형태로 변환',
    icon: '🔤',
    path: '/case-converter',
  },
  {
    id: 'whitespace-remover',
    name: '공백 제거',
    description: '불필요한 공백을 깔끔하게 정리',
    icon: '✂️',
    path: '/whitespace-remover',
  },
  {
    id: 'text-compare',
    name: '텍스트 비교',
    description: '두 텍스트의 차이점을 확인',
    icon: '🔄',
    path: '/text-compare',
  },
  {
    id: 'duplicate-remover',
    name: '중복 제거',
    description: '중복된 줄이나 단어를 정리',
    icon: '🧹',
    path: '/duplicate-remover',
  },
  {
    id: 'korean-converter',
    name: '한영 변환',
    description: '영타로 쓴 한글을 자동 변환',
    icon: '⚡',
    path: '/korean-converter',
  },
  {
    id: 'base64',
    name: 'Base64',
    description: 'Base64 인코딩/디코딩',
    icon: '🔐',
    path: '/base64',
  },
  {
    id: 'line-sorter',
    name: '줄 정렬',
    description: '여러 줄을 원하는 방식으로 정렬',
    icon: '📑',
    path: '/line-sorter',
  },
  {
    id: 'character-remover',
    name: '특수문자 제거',
    description: '원하는 문자만 남기기',
    icon: '🗑️',
    path: '/character-remover',
  },
  {
    id: 'lorem-ipsum',
    name: 'Lorem Ipsum',
    description: '디자인 목업용 샘플 텍스트 생성',
    icon: '📝',
    path: '/lorem-ipsum',
  },
];
